import { OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
var Formulario17Component = /** @class */ (function () {
    function Formulario17Component() {
        this.htmlcanvas = html2canvas;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.region = GLOBAL.region;
        this.pages = [1, 2];
    }
    Formulario17Component.prototype.ngOnInit = function () {
    };
    Formulario17Component.prototype.ngAfterContentChecked = function () {
        this.ngAfterContentInit();
    };
    Formulario17Component.prototype.ngAfterContentInit = function () {
        //TIPO RECEPCION
        if (JSON.parse(localStorage.getItem("tipo_recepcion"))) {
            if (JSON.parse(localStorage.getItem("tipo_recepcion")).length > 0) {
                this.tipo_recepcion = JSON.parse(localStorage.getItem("tipo_recepcion"));
            }
            else {
                localStorage.setItem("tipo_recepcion", JSON.stringify([]));
                this.tipo_recepcion = [{ "option": '' }];
            }
        }
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("propiedad"))) {
            if (JSON.parse(localStorage.getItem("propiedad")).length > 0) {
                this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
            }
            else {
                localStorage.setItem("propiedad", JSON.stringify([]));
                this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }];
            }
        }
        //PROPIETARIOS
        if (JSON.parse(localStorage.getItem("propietarios"))) {
            if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
                this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
            }
            else {
                localStorage.setItem("propietarios", JSON.stringify([]));
                this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //REPRESENTANTE
        if (JSON.parse(localStorage.getItem("representantes"))) {
            if (JSON.parse(localStorage.getItem("representantes")).length > 0) {
                this.representantes = JSON.parse(localStorage.getItem("representantes")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
            }
            else {
                localStorage.setItem("representantes", JSON.stringify([]));
                this.representantes = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //PERMISO NOTARIADO
        if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
            if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
                this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
            }
            else {
                localStorage.setItem("permiso_notariado", JSON.stringify([]));
                this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }];
            }
        }
        //ARQUITECTOS
        if (JSON.parse(localStorage.getItem("arquitectos"))) {
            if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
                this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
            }
            else {
                localStorage.setItem("arquitectos", JSON.stringify([]));
                this.arquitectos = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //EMPRESAS
        if (JSON.parse(localStorage.getItem("empresas"))) {
            if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
                this.empresas = JSON.parse(localStorage.getItem("empresas"));
            }
            else {
                localStorage.setItem("empresas", JSON.stringify([]));
                this.empresas = [{ rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //PERMISOS
        if (JSON.parse(localStorage.getItem("Permisos"))) {
            if (JSON.parse(localStorage.getItem("Permisos")).length > 0) {
                this.permisos = JSON.parse(localStorage.getItem("Permisos"));
            }
            else {
                localStorage.setItem("Permisos", JSON.stringify([]));
                this.permisos = [{ perm_numero: 0, perm_fecha: null, superfm2: 0, modproy: 'false', resolucion: 0, fecha_resol: null, perm_prim: 0, fecha_prim: null, recepcion: 0, fecha_recep: null, recordId: '' }];
            }
        }
        //RECEPCION PARCIAL
        if (JSON.parse(localStorage.getItem("recepcion_parcial"))) {
            if (JSON.parse(localStorage.getItem("recepcion_parcial")).length > 0) {
                this.recepcion_parcial = JSON.parse(localStorage.getItem("recepcion_parcial"));
            }
            else {
                localStorage.setItem("recepcion_parcial", JSON.stringify([]));
                this.recepcion_parcial = [{ superedif: '', cambios: 'false' }];
            }
        }
    };
    Formulario17Component.prototype.captureScreen = function () {
        var _this = this;
        var pdf = new jspdf('p', 'mm', 'a4');
        this.htmlcanvas(document.getElementById("page1")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 295);
        });
        this.htmlcanvas(document.getElementById("page2")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        /*this.htmlcanvas(document.getElementById(`page3`)).then(canvas => {
          const contentDataURL = canvas.toDataURL('image/png')
          pdf.addPage();
          pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)
        });*/
        setTimeout(function () {
            pdf.save(_this.propietarios[0].rut + '.pdf');
            // pdf.save('prueba.pdf')
        }, 6000);
    };
    return Formulario17Component;
}());
export { Formulario17Component };
